import React, { Fragment, useEffect } from "react";
import { snakeCase } from "lodash";
import { useHistory } from "react-router";
import Box from "@mui/material/Box";
import Paper from "@mui/material/Paper";
import { useLocalStore, useStoreActions } from "easy-peasy";
import I18n from "utils/i18n.js";
import { pageRoutes } from "services/api";
import PhoneNumbersForm from "components/admin_v2/common/PhoneNumbersForm";
import { PrimaryBtn } from "components/admin_v2/ui/Buttons";
import Spinner from "components/admin_v2/ui/Spinner";
import DistrictDetailsForm from "./DistrictDetailsForm";
import { districtFormStore } from "components/admin_v2/district_config/stores/districtFormStore";
import useCommonPageStyles from "components/admin_v2/common/useCommonPageStyles";

const DistrictForm = ({ district }) => {
  const cls = useCommonPageStyles();
  const history = useHistory();
  const formStore = useLocalStore(() => districtFormStore(district));
  const [state, actions] = formStore;
  const { setFlashMessage, updateScopes, updateDistricts } = useStoreActions((s) => s.app);

  useEffect(() => {
    actions.fetchAllSchools();

    return () => {
      actions.setAllSchools([]);
    };
  }, []);

  if (state.loading) return <Spinner />;

  const onSubmit = () => {
    actions
      .save()
      .then((resp) => {
        setFlashMessage({ message: resp.message });
        updateScopes({ force: true });
        history.push(pageRoutes.district(resp.district.id));
        updateDistricts();
      })
      .catch((err) =>
        setFlashMessage({
          message:
            err.response?.data?.message ||
            I18n.t("data_management.errors.fail", { name: "District" })
        })
      );
  };

  const forms = {
    details: <DistrictDetailsForm formStore={formStore} />,
    phoneNumbers: <PhoneNumbersForm store={formStore} phoneRequired={false} withTwilio={true} />
  };

  return (
    <Fragment>
      {Object.entries(forms).map(([formTitle, form]) => (
        <Box key={formTitle} my={2.5} className={`district-form-${snakeCase(formTitle)}`}>
          <Paper className={cls.paper}>
            <div className={cls.subTitle}>
              {I18n.t(`district_config.district.title.${snakeCase(formTitle)}`)}
            </div>
            {form}
          </Paper>
        </Box>
      ))}
      <Box my={5}>
        <PrimaryBtn size="large" onClick={onSubmit} disabled={state.loading || !state.isValid}>
          {I18n.t("ui.btn.save")}
        </PrimaryBtn>
      </Box>
    </Fragment>
  );
};

export default DistrictForm;
